import { DesignRoute, NavRoute } from 'application/types/routes';

import { useCurrentPlan } from 'organizations/hooks/useCurrentPlan';
import { usePlanCapability } from 'organizations/hooks/usePlanCapability';

import { Separator } from 'components/Separator/Separator';
import { Sidebar } from 'components/Sidebar/Sidebar';
import { SidebarLink } from 'components/Sidebar/SidebarLink';
import { Text } from 'components/Text/Text';
import { UpgradeCallout } from 'components/UpgradeCallout/UpgradeCallout';
import { PricingPlanLabel } from 'pipelines/components/PricingPlanLabel/PricingPlanLabel';

export function DesignSidebar() {
  const { isRingPlan, isSimplifiedUxPlan } = useCurrentPlan();
  const {
    isEnabled: canCreateCustomModels,
    isDisabled: isCustomModelsDisabledByPlan,
  } = usePlanCapability('can_create_custom_models');

  const showReadyToUseModels = !isRingPlan;
  const showWorkflowTemplates = !isSimplifiedUxPlan;
  const showCustomModelsUpgrade =
    isCustomModelsDisabledByPlan && !isSimplifiedUxPlan;
  const showCustomModelsLink = canCreateCustomModels || showCustomModelsUpgrade;
  const showYourWorkflowsSection =
    showWorkflowTemplates || showCustomModelsLink;
  const showUpgradeCallout = isSimplifiedUxPlan && !isRingPlan;

  const upgradeCallout = showUpgradeCallout ? (
    <UpgradeCallout>
      Upgrade to build your own workflows or custom models.
    </UpgradeCallout>
  ) : undefined;

  return (
    <Sidebar footer={upgradeCallout}>
      <li>
        <Text>
          <strong>Analytics Library</strong>
        </Text>

        <ul>
          <SidebarLink
            to={`/${NavRoute.DESIGN}/${DesignRoute.SOLUTIONS}`}
            icon="pipeline"
          >
            Ready-to-use workflows
          </SidebarLink>
          {showReadyToUseModels && (
            <SidebarLink
              to={`/${NavRoute.DESIGN}/${DesignRoute.MARKETPLACE}`}
              icon="model"
            >
              Ready-to-use AI Models
            </SidebarLink>
          )}
        </ul>
      </li>
      {showYourWorkflowsSection && (
        <>
          <Separator decorative />
          <li>
            <ul>
              <Text>
                <strong>Your workflows</strong>
              </Text>
              {showWorkflowTemplates && (
                <SidebarLink
                  to={`/${NavRoute.DESIGN}/${DesignRoute.PIPELINES}`}
                  icon="pipeline"
                >
                  Workflow templates
                </SidebarLink>
              )}
              {showCustomModelsLink && (
                <SidebarLink
                  to={`/${NavRoute.DESIGN}/${DesignRoute.MODELS}`}
                  icon="model"
                  action={
                    showCustomModelsUpgrade ? (
                      <PricingPlanLabel hasLink placement="inline" />
                    ) : undefined
                  }
                >
                  AI Models
                </SidebarLink>
              )}
            </ul>
          </li>
        </>
      )}
    </Sidebar>
  );
}
